import { render, staticRenderFns } from "./ClienteManual.vue?vue&type=template&id=7bec217c&scoped=true"
import script from "./ClienteManual.vue?vue&type=script&lang=js"
export * from "./ClienteManual.vue?vue&type=script&lang=js"
import style0 from "./ClienteManual.vue?vue&type=style&index=0&id=7bec217c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec217c",
  null
  
)

export default component.exports